/**
 * This file holds repository-wide constants that are reusable by more than 1 component.
 */

/**
 * A delay [ms] after which it's OK to update a live region content,
 * taking under consideration delayed programmatic refocusing
 * of triggering components (e.g., SelectInput) and Accessibility
 * Tree updates that prevent the screen reader announcements.
 */
export const WDS_LIVE_REGION_DELAY_MS = 175;
